.action-box {
    min-height: 40px;
}

.action-box--small {
    composes: action-box;
    min-height: 36px;
}

.action-box > * {
    min-width: 0;
}

.action-box > *:last-child:not(:only-child) {
    flex-shrink: 0;
    margin-left: 16px;
}

.action-box ul {
    margin-top: 16px;
}

/* .action-box > button {
    padding: 0;
} */

.action-box > button[data-type='link'] {
    padding: 0;
}

.icon {
    align-self: center;
    margin-right: 16px;
    height: 24px;
    display: flex;
    align-items: center;
}

.icon > * {
    max-height: 100%;
}

.title {
    font-weight: 500;
    color: var(--grey-dk);
    font-size: var(--font-big);
    line-height: 21px;
    margin-bottom: 2px;
}

.body {
    font-weight: normal;
    color: var(--grey);
    font-size: var(--font-normal);
    line-height: 19px;
}

.action-box--small .title {
    font-size: var(--font-normal);
}

.action-box--small .body {
    font-weight: normal;
    font-size: var(--font-small);
}
